<!--
  File name: Admin.vue
  Program Description:
    - This compoonent includes the side bar naviagtion of the DBNMS project
    - This also include the header containing the user name and role and a way to:<style scoped>
      * Navigate to profile page
      * Logout
    - Fetches the Dashboard component and display it for user view

    Includes:
    - Function that fetches the logged in user profile
-->
<template>
  <Dashboard
    :show-drawer="true"
  >
    <template v-slot:drawer>
      <v-list>
        <v-list-item-group color="primary">
          <v-divider />
          <DrawerItem
            label="Home"
            :href="{ name: 'AdminDashboard' }"
            icon="mdi-home"
          />
          <v-list-group no-action>
            <template
              v-slot:activator
            >
              <v-list-item-action>
                <v-icon>mdi-view-dashboard</v-icon>
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-title class="text-wrap">
                  <v-btn
                    id="dashboard-button"
                    class="pa-0 ma-0 transparent"
                    :ripple="false"
                    elevation="0"
                    style="text-transform: capitalize; letter-spacing: inherit"
                  >
                    Dashboard
                  </v-btn>
                </v-list-item-title>
              </v-list-item-content>
            </template>
            <DrawerItem
              id="reports-generation-pdbnf-button"
              label="DBN Reports"
              :href="{ name: 'Reports' }"
              :indent="'ps-12 ml-5'"
            />
            <DrawerItem
              id="reports-generation-asir-button"
              label="ASIR Reports"
              :href="{ name: 'ReportsAsir' }"
              :indent="'ps-12 ml-5'"
            />
            <!-- <DrawerItem
              id="sector-button"
              label="SECTOR"
              :href="{ name: 'SectorTable' }"
              :indent="'ps-12 ml-5'"
            /> -->
          </v-list-group>
          <template v-if="canViewMenu">
            <v-divider />
            <v-col>
              <span class="subtitle-2">Main Menu</span>
            </v-col>
          </template>
          <DrawerItem
            v-if="showLabel('canCreateRole')"
            id="user-management-button"
            :label="getLabel('canCreateRole', 'Users')"
            :href="{ name: 'AdminUsersList', params: { userRole: 'admin'} }"
            icon="mdi-account-multiple"
          />
          <DrawerItem
            v-if="showLabel('canViewAllPdbnf')"
            :label="getLabel('canViewAllPdbnf', 'Data Breach Notification')"
            :href="{ name: 'DataBreachTable', params: { dataTab: 'pdbnf'} }"
            icon="mdi-shield-alert"
          />
          <DrawerItem
            v-if="showLabel('canViewAllAsir')"
            :label="getLabel('canViewAllAsir', 'Annual Security Incident Report')"
            :href="{ name: 'SecurityIncidentTable' }"
            icon="mdi-shield-plus"
          />
          <v-list-group
            v-if="canViewAnalytics"
            no-action
          >
            <template
              v-slot:activator
            >
              <v-list-item-action>
                <v-icon>mdi-trending-up</v-icon>
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-title class="text-wrap">
                  <v-btn
                    id="analytics-and-ratings-btn"
                    class="pa-0 ma-0 transparent"
                    :ripple="false"
                    elevation="0"
                    style="text-transform: none; letter-spacing: inherit"
                  >
                    Analytics and Ratings
                  </v-btn>
                </v-list-item-title>
              </v-list-item-content>
            </template>
            <DrawerItem
              v-if="canViewIPCR"
              id="ipcr-btn"
              label="Individual Performance Commitment and Review"
              :href="{ name: 'Analytics', params: { dataTab: 'ipcr' }}"
              :indent="'ps-12 ml-5'"
            />
            <DrawerItem
              v-if="canViewDPCR"
              id="dpcr-btn"
              label="Division Performance Commitment and Review"
              :href="{ name: 'Analytics' , params: { dataTab: 'dpcr'}}"
              :indent="'ps-12 ml-5'"
            />
          </v-list-group>
          <v-list-group
            v-if="showLabel('canCreateRole')"
            no-action
          >
            <template
              v-slot:activator
            >
              <v-list-item-action>
                <v-icon>mdi-folder</v-icon>
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-title class="text-wrap">
                  <v-btn
                    id="master-data-button"
                    class="pa-0 ma-0 transparent"
                    :ripple="false"
                    elevation="0"
                  >
                    {{ getLabel('canCreateRole', 'Master Data') }}
                  </v-btn>
                </v-list-item-title>
              </v-list-item-content>
            </template>
            <DrawerItem
              id="cause-of-incident-button"
              label="CAUSE OF INCIDENT"
              :href="{ name: 'CauseOfIncidentTable' }"
              :indent="'ps-12 ml-5'"
            />
            <DrawerItem
              id="sector-button"
              label="SECTOR"
              :href="{ name: 'SectorTable' }"
              :indent="'ps-12 ml-5'"
            />
            <DrawerItem
              id="notification-types-button"
              label="NOTIFICATION TYPE"
              :href="{ name: 'NotificationTypesTable'}"
              :indent="'ps-12 ml-5'"
            />
            <DrawerItem
              id="nature-of-breach-button"
              label="NATURE OF BREACH"
              :href="{ name: 'NatureOfBreachTable'}"
              :indent="'ps-12 ml-5'"
            />
            <DrawerItem
              id="dbn-status-button"
              label="DBN STATUS"
              :href="{ name: 'DbnStatusTable' }"
              :indent="'ps-12 ml-5'"
            />
            <DrawerItem
              id="record-type-button"
              label="RECORD TYPE"
              :href="{ name: 'RecordTypeTable' }"
              :indent="'ps-12 ml-5'"
            />
          </v-list-group>
        </v-list-item-group>
      </v-list>
    </template>
    <template
      v-slot:menu
    >
      <div style="display: flex; padding: 20px 0;">
        <v-btn
          icon
          @click="displayNotifications"
        >
          <notification-bell
            :size="30"
            :upper-limit="50"
            :count="notifsCount"
            counter-location="upperRight"
            counter-style="round"
            counter-background-color="#FF0000"
            counter-text-color="#FFFFFF"
            icon-color="#000000"
          />
        </v-btn>
      </div>
      <div>
        <NotificationsDialog
          v-model="showNotificationsDialog"
          @notificationsCount="notificationsCount"
        />
      </div>
      <v-menu
        offset-y
        nudge-bottom="15"
        color="transparent"
        close-on-click
      >
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            id="profile-dropdown-btn"
            elevation="0"
            color="transparent"
            v-bind="attrs"
            :ripple="false"
            class="noUpperCase"
            v-on="on"
            @click="rotate"
          >
            <v-btn
              class="mr-5"
              icon
              disabled
            >
              <v-img :src="`${$metaData.app.userIcon}`" />
            </v-btn>
            <v-card
              class="transparent"
              flat
            >
              <v-list-item-title
                :style="{fontWeight: '600',fontColor: '#000', fontSize: '18px', textAlign: 'start'}"
              >
                {{ displayName }}
                <v-icon
                  class="ml-1 mt-n1"
                  :class="{rotate: rotateBtn}"
                >
                  mdi-chevron-down
                </v-icon>
              </v-list-item-title>
              <v-list-item-subtitle
                style="font-weight: 600; text-align: left "
              >
                {{ displayRole }}
              </v-list-item-subtitle>
            </v-card>
          </v-btn>
        </template>
        <v-list
          class="px-0 rounded"
        >
          <v-card-subtitle class="py-1">
            Roles
          </v-card-subtitle>
          <v-card-text class="black--text py-0 pb-1 font-weight-black">
            {{ displayRole }}
          </v-card-text>
          <v-divider />
          <v-card-actions
            class="pa-0 d-flex flex-column"
          >
            <router-link
              id="profile-btn"
              :to="{name: 'AdminAccount'}"
              style="width: 100%; "
            >
              <v-list-item
                link
                class="pl-2"
              >
                <v-icon
                  class="mr-2"
                >
                  mdi-account-box
                </v-icon>
                My Profile
              </v-list-item>
            </router-link>
            <v-dialog
              max-width="260px"
              persistent
            >
              <template
                v-slot:activator="{on}"
              >
                <v-list-item
                  id="logout-btn"
                  class="pl-2 btn-height"
                  style="width: 100%"
                  v-on="on"
                >
                  <v-icon
                    class="mr-2"
                  >
                    mdi-logout
                  </v-icon>
                  Logout
                </v-list-item>
              </template>
              <template v-slot:default="dialog">
                <v-card>
                  <v-card-title
                    style="font-size: 16px;"
                    class="danger--text text--darken-2 font-weight-bold"
                  >
                    Logout DBNMS
                  </v-card-title>
                  <v-card-text
                    style="font-size: 14px"
                    class="grey--text text--darken-2"
                  >
                    Are you sure you want to logout in DBNMS?
                  </v-card-text>
                  <v-card-actions class="d-flex justify-end">
                    <v-btn
                      id="cancel-logout-btn"
                      text
                      style="letter-spacing: normal;"
                      class=" grey--text text--darken-1 "
                      @click="dialog.value = false"
                    >
                      Cancel
                    </v-btn>
                    <v-btn
                      id="confirm-logout-btn"
                      style="letter-spacing: normal;"
                      text
                      class="danger--text text--darken-2"
                      @click="logout"
                    >
                      Yes, Logout
                    </v-btn>
                  </v-card-actions>
                </v-card>
              </template>
            </v-dialog>
          </v-card-actions>
        </v-list>
      </v-menu>
    </template>
    <template v-slot:content>
      <router-view
        ref="routerView"
        @alert="bubbleAlert($event)"
      />
    </template>
  </Dashboard>
</template>

<script>
import { capitalize, fullName } from '@/utils/helpers'
import Dashboard from '@/components/Dashboard'
import DrawerItem from '@/components/DrawerItem'
import { metaMixin } from '@/meta'
import alertMixin from '@/mixins/alertMixin'
import { privilegeMixin } from 'session-plugin'
import users from '@/utils/webapi/users'
import { mapGetters } from 'vuex'
import NotificationsDialog from '@/components/notifications/NotificationsDialog'
import { socket, authSocket } from '@/socket'
import NotificationBell from 'vue-notification-bell'

export default {
  name: 'Admin',
  components: {
    NotificationBell,
    NotificationsDialog,
    Dashboard,
    DrawerItem
  },
  mixins: [metaMixin, alertMixin, privilegeMixin],
  data: () => ({
    rotateBtn: false,
    $drawer: false,
    notifications: [],
    showNotificationsDialog: false
  }),
  computed: {
    ...mapGetters('lookups', {
      profile: 'getCurrentUser'
    }),
    ...mapGetters('notifications', {
      notifsCount: 'getNotificationsCount',
      notificationValues: 'getNotificationValues'
    }),
    userRole () {
      return (this.$s && this.$s.userRole)
    },
    userRoleChecker () {
      return role => this.userRole && this.userRole.includes(role)
    },
    isAdmin: {
      get: function () {
        return (this.userRole && this.userRole.includes('admin'))
      },
      set: function () {}
    },
    isPic () {
      return (this.userRole && this.userRole.includes('pic'))
    },
    displayName () {
      if (this.$s.userRole && this.$s.userRole.includes('pic')) {
        return this.profile.organization
      }
      return this.profile.fullName
    },
    displayRole () {
      if (this.$s.userRole && this.$s.userRole.includes('pic')) {
        return 'PIC/PIP'
      }
      return this.profile.userRole
    },
    canViewMenu () {
      return (this.showLabel('canCreateRole') ||
      this.showLabel('canViewAllPdbnf') ||
      this.showLabel('canViewAllAsir'))
    },
    canViewIPCR () {
      const rolesArr = ['evaluator', 'assignor', 'reviewer']
      return this.userRole.some(role => rolesArr.includes(role))
    },
    canViewDPCR () {
      const rolesArr = ['divisionChief']
      return this.userRole.some(role => rolesArr.includes(role))
    },
    canViewAnalytics () {
      return this.canViewIPCR || this.canViewDPCR
    }
  },
  async beforeCreate () {
    await this.$store.dispatch('notifications/reset')
  },
  created () {
    this.$store.dispatch('initPrivileges')
    this.getProfile()
    this.initializeChat()
    if (!this.notifications.length) {
      this.fetchNotifications()
    }
  },
  destroyed () {
    socket.disconnect()
    socket.off('connect_error')
    window.location.reload()
  },
  methods: {
    async notificationsCount (notifs) {
      await this.$store.dispatch('notifications/setNotifications', { notifications: notifs })
    },
    // close or open Notifications Dialog
    displayNotifications () {
      this.showNotificationsDialog = !this.showNotificationsDialog
    },
    // get notifications
    fetchNotifications () {
      socket.emit('fetch notifications')
    },
    // connect sockets for notifications
    async initializeChat () {
      await this.$s.ready
      const { user: userID } = this.$s
      if (userID) {
        this.usernameAlreadySelected = true
        socket.auth = {
          userID
        }
      }
      socket.connect()
      socket.on('session', ({ userID }) => {
      // attach the session ID to the next reconnection attempts
        socket.auth = { userID }
      })

      socket.on('connect_error', (err) => {
        if (err.message === 'invalid username') {
          this.usernameAlreadySelected = false
        }
      })
      socket.on('notifications', async (notifs) => {
        this.count = 0
        notifs && notifs.details.forEach((item) => {
          !item.seen && this.count++
        })
        if (this.count <= this.$store.state.notifications.count || this.$store.state.notifications.count === 0) {
          this.$store.commit({
            type: 'notifications/setNotificationsCount',
            notificationsCount: this.count
          })
          await this.$store.dispatch('notifications/setNotificationValues', { notificationValues: notifs })
        }
        this.notifications = notifs && notifs.details ? notifs.details : []
      })
      socket.on('new notifications', async (notifs) => {
        this.count = 0
        notifs && notifs.details.forEach((item) => {
          !item.seen && this.count++
        })
        this.$store.commit({
          type: 'notifications/setNotificationsCount',
          notificationsCount: this.count
        })
        await this.$store.dispatch('notifications/setNotificationValues', { notificationValues: notifs })
        this.notifications = notifs.details
      })
      socket.on('disconnect', () => {
        authSocket.connect()
      })
    },
    // handle user logout
    async logout () {
      await this.$refs.ready
      if (this.$refs.routerView.$refs) {
        const refs = this.$refs.routerView.$refs
        const isAnalytics = this.$route.name === 'AnalyticsForm'
        if ((isAnalytics && !this.$refs.routerView.readOnly) || (refs.dataBreachForm && !refs.dataBreachForm.readOnly) || (refs.securityIncidentForm && !refs.securityIncidentForm.readOnly)) {
          if (this.$refs.routerView.confirmLeave()) {
            if (this.$s.userType === 'Internal') {
              this.$store.commit('lookups/setOpts', {
                type: 'isInternalLogin',
                payload: true
              })
            }
            this.$s.destroySession()
          }
        } else {
          if (this.$s.userType === 'Internal') {
            this.$store.commit('lookups/setOpts', {
              type: 'isInternalLogin',
              payload: true
            })
          }
          this.$s.destroySession()
        }
        socket.disconnect()
      }
    },
    // used to change class for button rotation of profile dropdown
    rotate () {
      this.rotateBtn = !this.rotateBtn
    },
    capitalize,
    // get profile of current user
    async getProfile () {
      const resp = await users.profile()
      const jData = await resp.json()
      if (jData.entry) {
        // const userRoleChecker = !jData.entry.userRole.includes('admin') || !jData.entry.userRole.includes('director') || !jData.entry.userRole.includes('divisionHead') || !jData.entry.userRole.includes('focalPerson')

        if (jData.entry && (jData.entry.userRole.includes('proponent') || jData.entry.userRole.includes('expert'))) {
          const { firstName, middleName, lastName, suffix, budgetOfficerOrAccountant, headOfResearch, auditorDetails } = jData.entry.agency
          const { salutation: budgetSalutation, firstName: budgetFirst, middleName: budgetMiddle, lastName: budgetLast, suffix: budgetSuffix } = budgetOfficerOrAccountant
          const { salutation: researchSalutation, firstName: researchFirst, middleName: researchMiddle, lastName: researchLast, suffix: researchSuffix } = headOfResearch
          const { salutation: auditorSalutation, firstName: auditorFirst, middleName: auditorMiddle, lastName: auditorLast, suffix: auditorSuffix } = auditorDetails

          jData.entry.agency = {
            ...jData.entry.agency,
            fullName: fullName(firstName, middleName, lastName, suffix),
            budgetOfficerOrAccountant: {
              fullName: fullName(budgetSalutation, budgetFirst, budgetMiddle, budgetLast, budgetSuffix)
            },
            headOfResearch: {
              fullName: fullName(researchSalutation, researchFirst, researchMiddle, researchLast, researchSuffix)
            },
            auditorDetails: {
              fullName: fullName(auditorSalutation, auditorFirst, auditorMiddle, auditorLast, auditorSuffix)
            }
          }
        }

        this.$store.commit('lookups/setCurrentUser', jData.entry)
      }
    }
  },
  session: {
    restrict: ['guest']
  }
}
</script>

<style scoped>
  .user {
    font-family: 'Source Sans Pro';
    font-size: 18px;
    text-transform: uppercase;
  }
  .fixed {
    position: absolute;
    width: 90%;
    left: 5%;
  }
  .rotate{
    transform: rotate(180deg);
  }
  .transparent {
    font-family: 'Source Sans Pro';
    background-color: transparent;
    font-size: 16px;
    letter-spacing: 1px;
  }
  .transparent:before {
    display: none;
  }
  .noUpperCase >>> {
    text-transform: none !important;
  }

</style>
